// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"HV-z","inlineTitle":"IV-z","sponsoredAdsWrapper":"JV-z","marketplaceRecosWrapper":"KV-z"};